import axios from "axios";
import _get from "lodash/get";
import config from '@/config'

const Client = {
    getPasswordSettings(policy = 'PASSWORD_POLICY_RUNBUGGY') {
        let path = `${config.accounts.api.path}/users/passwordSettings/${policy}`;
        return this.get(path);
    },
   
   // common calls
   get(path) {
        return axios.get(path);
   }
};

export default Client;